import React from 'react';
const IconWrapper = ({ children, size = 'medium', ...props }) => {
    if (!children)
        return null;
    const viewBox = size === 'small' ? '0 0 16 16' : '0 0 24 24';
    const iconSize = size === 'small' ? '16' : '24';
    return (React.createElement("svg", { viewBox: viewBox, xmlns: "http://www.w3.org/2000/svg", height: iconSize, width: iconSize, ...props }, children));
};
export default IconWrapper;
//# sourceMappingURL=IconWrapper.js.map